export default "__VITE_ASSET__CbifWQnC__"